import styled from 'styled-components';
import {
  Flex,
} from 'web-styled';

export const Exercises = styled(Flex).attrs({
  column: true,
})`
  width: 100%;
  padding: 5px 15px;
  overflow: auto;
  flex-shrink: 0;
  height: calc(100% - 143px);
`;

export const ButtonsGroup = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})`
  margin: 45px 0;
  padding: 0 20px;
  width: 100%;
`;
